// extracted by mini-css-extract-plugin
module.exports = {"heroBannerTextCenterWrapper":"HeroBannerShopContent_heroBannerTextCenterWrapper__Qq1WQ","titleImageContainer":"HeroBannerShopContent_titleImageContainer__HAvWb"};